import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import theme from './theme/theme';
import Layout from './components/layout/Layout';
import ToStructurePage from './pages/ToStructurePage';
import ZerveAnalyticsPage from './pages/ZerveAnalyticsPage';

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />} />
        <Route path="/tostructure" element={<ToStructurePage />} />
        <Route path="/zerveanalytics" element={<ZerveAnalyticsPage />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
);

export default App;
